import styled from 'styled-components';
import { IconButton as MUIIconButton } from '@mui/material';

export const IconButton = styled(MUIIconButton)`
  padding: 0 !important;
`;

IconButton.defaultProps = {
  size: 'small',
};
